import React from "react";
import { ReactSVG } from "react-svg";
import { EducationUITypes } from "./data";
import NewToolTip from "../../../../common/New-ToolTip";

const InformationPage = ({ cards = [], iconUrl = "", type = 0 }) => {
  return (
    <>
      {type === EducationUITypes.InfoCard && (
        <>
          {cards.map((card, key) => (
            <div
              className={`w-full relative group ${
                key % 2 === 1 ? "left-[960px] top-[60px]" : "left-[20px]"
              }`}
            >
              <div className="object-cover duration-1000 transition-transform ">
                {/* group-hover:opacity-100 group-hover:scale-105 */}
                <div
                  className={`absolute left-4 top-[5px] flex w-[183px] h-[183px] ${card.bgcolor} rounded-full shadow-lg shadow-gray-400`}
                ></div>
                <div
                  className={`absolute w-[773.59px] h-[271.15px] gap-[10px] top-[16.85px] left-[47.41px] py-6 pr-12 pl-[180px] flex flex-row rounded-[100px] border-4 ${card.color} bg-white bg-opacity-60 shadow-lg shadow-gray-400`}
                >
                  <div className="gap-3 flex flex-col">
                    <h3 className="flex flex-row text-[30px] font-semibold text-gray-800">
                      {card.title}
                      {card?.TooltipComp && (
                        <>
                          {" "}
                          <span className="flex">
                            <ReactSVG
                              src="/icons/information-dark.svg"
                              className="w-5 ml-2 mt-2"
                              data-tooltip-id={card.title}
                            />
                          </span>
                          <NewToolTip
                            id={card.title}
                            render={() => <card.TooltipComp />}
                          />
                        </>
                      )}
                    </h3>
                    <ul className="text-[22px] font-medium list-disc text-gray-600 pl-6">
                      {card.points.length === 0
                        ? card.content
                        : card.points.map((x) => <li>{x}</li>)}
                    </ul>
                  </div>
                </div>
                <div className="absolute top-12 left-[61px]">
                  <ReactSVG src={`/icons/${iconUrl}.svg`} />
                </div>
                <div
                  className={`absolute top-[-9px] flex items-center justify-center w-[82px] h-[82px] ${card.bgcolor} rounded-full border-[6px] border-white shadow-lg shadow-gray-400`}
                >
                  <h3 className="text-lg-display font-medium text-white">
                    {card.cardNumber}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
      {type === EducationUITypes.CircleCard && (
        <div className="flex justify-between min-w-[800px]">
          {cards.map((card, index) => (
            <div key={index} className="relative left-56">
              <div
                className="absolute w-[458px] h-[458px] border-[5px] border-gray-200 rounded-full flex items-center justify-center"
              >
                <div
                  className={`absolute top-[10%] left-[-24%] w-[173px] h-[173px] z-10 bg-REELOrange rounded-full items-center justify-center flex shadow-lg shadow-gray-400`}
                >
                  <div
                    className={`w-[157px] h-[157px] z-10 border-[5px] bg-gray-20 border-white rounded-full items-center justify-center flex`}
                  >
                    <h3 className="flex items-center text-[20px] font-semibold text-center text-gray-800">
                      {card.title}
                    </h3>
                  </div>
                </div>
                <span className="absolute flex w-[13px] h-[13px] rounded-full bg-REELOrange z-30 bottom-[38%] left-[-1%]"></span>
                <span className="absolute z-20 flex justify-center items-center w-[30px] h-[30px] rounded-full border-[3px] border-REELOrange top-[45%] left-[-4%] bg-white">
                  <span className="flex w-[19px] h-[19px] rounded-full bg-REELOrange"></span>
                </span>
                <div
                  className={`
                        w-[406px] h-[406px] bg-gray-20 rounded-full items-center justify-center flex shadow-lg shadow-gray-400`}
                >
                  <div
                    className={`w-[404px] h-[404px] border-[5px] border-white bg-gray-20 rounded-full items-center pt-24 flex flex-col gap-2`}
                  >
                    <ul className="flex flex-col text-lg font-medium text-gray-600 top-10 pl-12 pr-3 gap-1.5">
                      {card.points.length === 0
                        ? card.content
                        : card.points.map((x) => (
                            <li className="relative flex items-start justify-start">
                              <span className="absolute flex w-[12px] h-[12px] top-2 rounded-full border-[4px] border-REELOrange bg-white"></span>
                              <span className="flex w-full px-6">{x}</span>
                            </li>
                          ))}
                    </ul>
                  </div>
                </div>
                <span className="absolute flex w-[13px] h-[13px] rounded-full bg-REELOrange z-30 top-[35%] right-0"></span>
                <span className="absolute z-20 flex justify-center items-center w-[30px] h-[30px] rounded-full border-[3px] border-REELOrange top-[45%] right-[-4%] bg-white">
                  <span className="flex w-[19px] h-[19px] rounded-full bg-REELOrange"></span>
                </span>
                <div
                  className={`absolute top-[50%] left-[85%] flex justify-end w-[205.11px] h-[205.11px] bg-orange rounded-full opacity-80 shadow-lg shadow-gray-400`}
                >
                  <ReactSVG
                    src={`/icons/${
                      card.iconUrl !== undefined ? card.iconUrl : iconUrl
                    }.svg`}
                    className="flex opacity-100"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default InformationPage;
